import { sendAxiosRequest } from '../../utils/sendRequest';
import IUserResponse from '../../../models/responces/IUserResponse';
import UrlBuilder from '../../url/UrlBulder';

export interface ISignUpParams {
  firstName: string;
  email: string;
  pass: string;
  lastName?: string;
  promoCode?: string;
}

const signUp = (params: ISignUpParams) =>
  sendAxiosRequest({
    method: 'post',
    url: UrlBuilder.getURL({
      handler: 'auth',
      action: 'signup'
    }),
    data: params,
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IUserResponse>;
export default signUp;
